import React, { useEffect, useState } from "react";
import styles from "./OpioidAdherence.module.css";

import { IOpioidRes } from "../../hooks/patients/useFetchOpioidReport";

interface OpioidAdherenceCardProps {
  data?: IOpioidRes['data'];
}

const OpioidAdherenceCard: React.FC<OpioidAdherenceCardProps> = ({ data }) => {
  const isPrescribed = data?.isPatientCurrentlyPrescribed === 'yes';
  const [dosageChange, setDosageChange] = useState<string>("N/A");

  const hasNoData = !data || !data.isPatientCurrentlyPrescribed;

  useEffect(() => {
    if (data?.hasPatientTakeMedication) {
      const apiValue = data.hasPatientTakeMedication.toLowerCase();
      const valueMapping: { [key: string]: string } = {
        'n/a': 'N/A',
        'more': 'MORE',
        'less': 'LESS',
        'same_amount': 'SAME AMOUNT',
        'same amount': 'SAME AMOUNT'
      };
      
      if (valueMapping[apiValue]) {
        setDosageChange(valueMapping[apiValue]);
      } else {
        setDosageChange("N/A");
      }
    }
  }, [data]);

  const renderOptions = (showOptions: boolean) => {
    if (!data) return null;

    return (
      <>
        <div className={styles.subQuestion}>
          HAS PATIENT TAKEN MORE, LESS, OR THE SAME AMOUNT OF OPIOID MEDICATION(S)?
        </div>
        <div className={styles.optionRow}>
          {["N/A", "MORE", "LESS", "SAME AMOUNT"].map((option) => (
            <button
              key={option}
              className={`${styles.optionBtn} ${dosageChange === option ? styles.active : ""
                }`}
            >
              {option}
            </button>
          ))}
        </div>

      </>
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>OPIOID ADHERENCE</div>
      {hasNoData ? (
        <div className={styles.noData}>
          No data available
        </div>
      ) : (
        <>
          <div className={styles.question}>
            IS PATIENT CURRENTLY BEING PRESCRIBED AN OPIOID?
          </div>
          <div className={styles.btnRow}>
            <button
              className={`${styles.btn} ${isPrescribed ? styles.active : ""}`}
              disabled
            >
              YES
            </button>
            <button
              className={`${styles.btn} ${!isPrescribed ? styles.active : ""}`}
              disabled
            >
              NO
            </button>
          </div>
          {renderOptions(isPrescribed)}
        </>
      )}
    </div>
  );
};

export default OpioidAdherenceCard;
